import { useEffect } from 'react';
import { withVueRouter, connectVuex } from 'vuereact-combined';
const AuthenticatedApp = ({ $vueRouter, vuexCommit, data = {} }) => {
    const { sessionId, firstName, lastName, username, licenses, gradeLevel, id, settings } = data;
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        vuexCommit('student/setStudent', {
            sessionId,
            id,
            firstName,
            lastName,
            username,
            grade: gradeLevel,
            licenses: licenses,
            successfullyLoggedIn: true,
            accessibilitySettings: {
                audioSettings: Object.assign({ volume: 100, muteSounds: false }, ((_b = (_a = settings === null || settings === void 0 ? void 0 : settings.accessibility) === null || _a === void 0 ? void 0 : _a.audioSettings) !== null && _b !== void 0 ? _b : {})),
                closedCaptionsSettings: Object.assign({ showClosedCaptions: false, closedCaptionSize: 22 }, ((_d = (_c = settings === null || settings === void 0 ? void 0 : settings.accessibility) === null || _c === void 0 ? void 0 : _c.closedCaptionsSettings) !== null && _d !== void 0 ? _d : {})),
                videoNarrationSettings: {
                    showSettings: (_e = settings === null || settings === void 0 ? void 0 : settings.accessibility) === null || _e === void 0 ? void 0 : _e.videoNarrationSettings.showSettings
                }
            }
        }, { root: true });
        $vueRouter.push({ path: 'curriculum' }).catch(failure => {
            console.log({ failure });
            '';
        });
    }, []);
    return null;
};
export default connectVuex({
    mapCommitToProps(commit) {
        return {
            vuexCommit: commit
        };
    }
})(withVueRouter(AuthenticatedApp));
